
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"breadcramb-triangle"}},[_c('path',{attrs:{"id":"Vector 5","d":"M5.5 8.25L11 13.75L16.5 8.25","stroke":"white","stroke-width":"2.0625","stroke-linecap":"round"}})])])
          )
        }
      }
    